// Bed, Nest Bed and (since round 7 – bowl mat) Bowl Mat pages (7 Oct 2026): the native variant picker stays the source of truth. This script only
// decorates it: the price (or "Sold out") per size tile for the selected print, the legend's print name without its
// " + Insert" suffix, and the button and mobile-bar price following the selected variant. The picker replaces its own
// markup after every change, so the labels are re-applied through a MutationObserver. Nothing here submits, changes a
// choice or touches the cart. (8 Oct, Luuk: the colour radios are the theme's round swatches again, as on the collar
// page, so the print-name labels on the tiles are gone.)
(() => {
  const root = document.querySelector('.b2c-product[data-offer="bed"], .b2c-product[data-offer="nest"], .b2c-product[data-offer="mat"]');
  const picker = root?.querySelector('kit-variant-picker');
  const source = root?.querySelector('[data-bed-catalog]');
  if (!root || !picker || !source) return;
  let catalog;
  try { catalog = JSON.parse(source.textContent); } catch { return; }
  const variants = catalog.variants || [];
  const soldOut = catalog.lang === 'fr' ? 'Épuisé' : catalog.lang === 'de' ? 'Ausverkauft' : 'Sold out';
  const fieldsets = () => [...picker.querySelectorAll('fieldset')];
  // Colour products ("The Fritz Nest Bed - Striped") have a Size option only; the catalogue then carries an empty colour.
  const selectedColour = sets => sets.length > 1 ? (sets[0].querySelector('input[type="radio"]:checked')?.value || '') : '';
  const decorate = () => {
    const sets = fieldsets();
    if (!sets.length) return;
    if (sets.length > 1) {
      const legend = sets[0].querySelector('.kit-fieldset__legend-selection');
      if (legend) legend.textContent = legend.textContent.replace(/\s*\+\s*(insert|intérieur)\s*$/i, '');
    }
    const colour = selectedColour(sets);
    sets[sets.length - 1].querySelectorAll('.kit-radio').forEach(label => {
      const size = label.querySelector('input[type="radio"]')?.value || '';
      const variant = variants.find(row => row.colour === colour && row.size === size) || null;
      let price = label.querySelector('.b2c-size-price');
      if (!price) {
        price = document.createElement('span');
        price.className = 'b2c-size-price';
        label.appendChild(price);
      }
      price.dataset.available = String(!!variant?.available);
      price.textContent = variant ? (variant.available ? variant.money : soldOut) : '';
    });
  };
  const follow = variant => {
    const row = variant && variants.find(item => item.id === Number(variant.id));
    if (!row) return;
    root.style.setProperty('--b2c-price-label', `'${row.money.replace(/'/g, '')}'`);
    const sticky = root.querySelector('[data-sticky-price]');
    if (sticky) sticky.textContent = row.money;
  };
  document.addEventListener(`variant:change:${picker.dataset.sectionId}:${picker.dataset.productId}`, event => {
    const {variant, loading} = event.detail || {};
    if (loading || !variant) return;
    follow(variant);
    decorate();
  });
  new MutationObserver(decorate).observe(picker, {childList: true});
  decorate();
  try { follow(JSON.parse(picker.querySelector('[data-kit-selected-variant]')?.textContent || 'null')); } catch {}
})();
